/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * Each user can be referred to Devour with a referral code; this models that relationship .
 * @export
 * @interface ReferralRelationship
 */
export interface ReferralRelationship {
    /**
     * 
     * @type {string}
     * @memberof ReferralRelationship
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralRelationship
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralRelationship
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralRelationship
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRelationship
     */
    referredUser: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRelationship
     */
    eventTypeReferralClaimed?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralRelationship
     */
    relationshipType: RelationshipType;
}



/**
 * Check if a given object implements the ReferralRelationship interface.
 */
export function instanceOfReferralRelationship(value: object): value is ReferralRelationship {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('referredUser' in value) || value['referredUser'] === undefined) return false;
    if (!('relationshipType' in value) || value['relationshipType'] === undefined) return false;
    return true;
}

export function ReferralRelationshipFromJSON(json: any): ReferralRelationship {
    return ReferralRelationshipFromJSONTyped(json, false);
}

export function ReferralRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRelationship {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'code': json['code'],
        'referredUser': json['referredUser'],
        'eventTypeReferralClaimed': json['eventTypeReferralClaimed'] == null ? undefined : json['eventTypeReferralClaimed'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
    };
}

export function ReferralRelationshipToJSON(json: any): ReferralRelationship {
    return ReferralRelationshipToJSONTyped(json, false);
}

export function ReferralRelationshipToJSONTyped(value?: ReferralRelationship | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'code': value['code'],
        'referredUser': value['referredUser'],
        'eventTypeReferralClaimed': value['eventTypeReferralClaimed'],
        'relationshipType': RelationshipTypeToJSON(value['relationshipType']),
    };
}

